"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AppointmentListCountsSchema () {
        return AppointmentListCountsSchema;
    },
    get AppointmentListItemSchema () {
        return AppointmentListItemSchema;
    },
    get AppointmentListQuerySchema () {
        return AppointmentListQuerySchema;
    },
    get AppointmentListResponseSchema () {
        return AppointmentListResponseSchema;
    }
});
const _zod = require("zod");
const _appointmentcancellation = require("./appointment-cancellation");
const _appointmentstatus = require("./appointment-status");
const _visittype = require("./visit-type");
const AppointmentListQuerySchema = _zod.z.object({
    date: _zod.z.string().date(),
    providerId: _zod.z.string().uuid().optional()
}).strict();
const AppointmentListItemSchema = _zod.z.object({
    id: _zod.z.string().uuid(),
    scheduledAt: _zod.z.string().datetime({
        offset: true
    }),
    updatedAt: _zod.z.string().datetime({
        offset: true
    }),
    durationMinutes: _zod.z.number().int().positive(),
    status: _appointmentstatus.AppointmentStatusSchema,
    visitType: _visittype.VisitTypeSchema,
    reason: _zod.z.string().nullable(),
    room: _zod.z.string().nullable(),
    patient: _zod.z.object({
        id: _zod.z.string().uuid(),
        givenName: _zod.z.string(),
        familyName: _zod.z.string()
    }),
    provider: _zod.z.object({
        id: _zod.z.string().uuid(),
        displayName: _zod.z.string().nullable()
    }),
    cancellation: _appointmentcancellation.AppointmentCancellationItemSchema.nullable()
});
const CountSchema = _zod.z.number().int().min(0);
const AppointmentListCountsSchema = _zod.z.object({
    total: CountSchema,
    scheduled: CountSchema,
    checked_in: CountSchema,
    in_consult: CountSchema,
    completed: CountSchema,
    no_show: CountSchema,
    cancelled: CountSchema
});
const AppointmentListResponseSchema = _zod.z.object({
    date: _zod.z.string().date(),
    timezone: _zod.z.string().min(1),
    items: _zod.z.array(AppointmentListItemSchema),
    counts: AppointmentListCountsSchema
});
